import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';

import React from 'react';

// const items = [
//     {
//         label: <a href="https://www.antgroup.com">1st menu item</a>,
//         key: '0',
//     },
//     {
//         label: <a href="https://www.aliyun.com">2nd menu item</a>,
//         key: '1',
//     },
//     {
//         type: 'divider',
//     },
//     {
//         label: '3rd menu item',
//         key: '3',
//     },
// ];

const DropDown = ({ items, trigger }) => {
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={[trigger]}
    >
      <button
        type="button"
        onClick={(e) => e.preventDefault()}
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        <Space>
          Click me
          <DownOutlined />
        </Space>
      </button>
    </Dropdown>
  );
};

export default DropDown;
